import { Section } from "src/utils"
import s from "./InvestmentModule.module.scss"
import { Container } from "src/layout/container/Container"

import InvestmentOverlay from "src/components/investment-overlay/InvestmentOverlay"
import React from "react"
import InitialStep from "src/components/investment-overlay/investment-steps/InitialStep"
import { SanityRichText } from "src/sanity/types"

export interface StartInvestmentTab {
    moneyAmount: number
    tabCurrency: string
    id:string
}

export interface MonthlyInvestmentTab {
    moneyAmount: number
    tabCurrency: string
    id:string
}

export interface RadioLabel {
    radioLabel: string
    id: string
}

interface InvestmentModuleProps {
    rate:number
    period: number
    maxYears: number
    startInvestmentTabs: StartInvestmentTab[]
    monthlyInvestmentTabs: MonthlyInvestmentTab[]
    radioLabels: RadioLabel[]
    investmentInputStartLabel: string
    investmentInputMonthlyLabel: string
    investmentInputStartPlaceholder: string
    investmentInputMonthlyPlaceholder: string
    initialStepHeading: string
    initialStepDescription:string
    initialStepButtonLabel: string
    initialStepExamplePrincipal: number
    initialStepInfoboxMaxYearsUnitLabel: string
    initialStepExampleMontlyAmount: number
    firstMiddleStepNumber: string
    firstMiddleStepHeading: string
    firstMiddleStepDescription: string
    secondMiddleStepNumber: string
    secondMiddleStepHeading: string
    secondMiddleStepDescription: string
    thirdMiddleStepNumber: string
    thirdMiddleStepHeading: string
    thirdMiddleStepDescription: string
    middleStepPreviousButtonLabel: string
    middleStepNextButtonLabel: string
    thirdMiddleStepSeeResultButtonLabel: string
    finalStepTitle: string
    finalStepCalculationDescription: string
    finalStepButtonLabel: string
    finalStepModalButtonText: string
    finalStepStartMoneyAmountSummary: string
    finalStepMonthlyMoneyAmountSummary: string
    finalStepRadioInputSummary: string
    currency: string
    zeroInterestRateLabel: string
    estimatedRefundLabel: string
    tooltipTitle: string
    howisThisCalculatedModalTitle?: string
    howisThisCalculatedModalContent: SanityRichText
    riskInfo: string
    initialStepInfoboxHeadline: string
    initialStepInfoboxSubHeadline: string
    initialStepInfoboxPrincipalLabel: string
    initialStepInfoboxRateLabel: string
    initialStepInfoboxMonthlyPaymentsLabel: string
    initialStepInfoboxMaxYearsLabel: string
}

export default function InvestmentModule(props: InvestmentModuleProps) {
    const [stepValue, setStepValue] = React.useState(0)

    function handleNextStep() {
        setStepValue(stepValue + 1)

    }
    function handlePreviousStep() {
        setStepValue(stepValue - 1)
    }

    return (
        <Section>
            <Container>
                <InitialStep
                    sharedClasses={{
                        stepContainer: s["investment-module__step"],
                        textContainer: s["investment-module__text-container"],
                        description: s["investment-module__description"],
                    }}
                    onNextStep={handleNextStep}
                    {...props}
                />
            </Container>
            <InvestmentOverlay
                stepValue={stepValue}
                handleNextStep={handleNextStep}
                handlePreviousStep={handlePreviousStep}
                setStepValue={setStepValue}
                {...props}
            />
        </Section>
    )
}
